import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NewBankInformation from './NewBankInformation';
import '../scss/bank-info-modal.style.scss';

interface BankInfoModalProps {
  show: boolean;
  onClose: () => void;
}

const BankInfoModal: React.FC<BankInfoModalProps> = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} centered size="lg" onHide={onClose} className="bank-info-modal">
      <Modal.Header>
        <Modal.Title>
          {t('Please Add Your Bank Information')}
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
          style={{ position: 'absolute', right: '16px', top: '16px' }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body style={{ overflow: 'auto' }}>
        <NewBankInformation 
          setShowBankInfoPopup={onClose} 
          showBankInfoPopup={show}
          isPopup={true}
        />
      </Modal.Body>
    </Modal>
  );
};

export default BankInfoModal;
